import React, { useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import AddTestSurveyModalCst from "@components/AddTestSurveyModalCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";
import AssociationFieldPlaceholder from "../AssociationFieldPlaceholder";

const SurveyContent: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");

  const [pickerOpen, setPickerOpen] = useState(false);

  const handleCreateNew = (tabKey?: string) => {
    console.info("[activity-wizard] crea nuovo survey — TODO", tabKey);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <AssociationFieldPlaceholder
        label={t("content.survey.label")}
        required
        value={data.survey_id}
        onChange={(next) => setData({ survey_id: next })}
        addLabel={t("common.add") || "Aggiungi"}
        emptyLabel={t("common.empty") || "Nessun elemento aggiunto"}
        error={!!errors.survey_id}
        errorMessage={
          errors.survey_id ? t(`errors.${errors.survey_id}`) || "" : ""
        }
        onAddClick={() => setPickerOpen(true)}
      />

      <AddTestSurveyModalCst
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        onConfirm={(selection) => {
          if (selection)
            setData({
              survey_id: { id: selection.id, label: selection.label },
            });
        }}
        onCreate={handleCreateNew}
        initialTab="survey"
        visibleTabs={["survey"]}
      />
    </Box>
  );
};

export default SurveyContent;
